// Styles
import './DeliveryNotes.scss';

// Libs
import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Blocks
import ButtonLoading from '@/common/components/molecules/ButtonLoading/ButtonLoading';
// Components
import SelectField from '@/common/components/molecules/SelectField/SelectField';

// PropTypes
import {
  DeliveryNotesDefaultProps,
  DeliveryNotesPropTypes,
} from './DeliveryNotes.proptypes';
// Hooks
import useDeliveryNote from './useDeliveryNote';

const DeliveryNotes = ({ deliveryNotes, disabled, isLoading, orderId }) => {
  const { t } = useTranslation();

  const {
    deliveryNoteFormats,
    deliveryNotesList,
    isDisabled,
    onDownloadDeliveryNote,
    onIsDisabled,
  } = useDeliveryNote({
    disabled,
    isLoading,
    deliveryNotes,
  });

  return (
    <div
      className="modal-delivery-notes__content"
      data-qa-id="modal-delivery-notes"
    >
      <h1 className="rs-modal-title">
        {t('ebat:entities:orders.modal.delivery_notes.title')}
      </h1>
      <div className="description">
        <p>{t('ebat:entities:orders.modal.delivery_notes.description')}</p>
      </div>
      <Formik
        initialValues={{
          deliveryNote: '',
          format: '',
        }}
        onSubmit={async (values) => {
          onDownloadDeliveryNote(values.deliveryNote, orderId, values.format);
        }}
      >
        {({ errors, touched, values }) => (
          <Form className="form modal-form" data-qa-id="delivery-notes-form">
            <div className="modal-form__fields">
              {deliveryNotes && (
                <Field
                  as={SelectField}
                  context="delivery-note-field"
                  disabled={isDisabled.disabled}
                  errors={
                    errors.deliveryNote &&
                    touched.deliveryNote && [
                      t(
                        `common:messages:forms.validation.${errors.deliveryNote}`,
                      ),
                    ]
                  }
                  id="deliveryNote"
                  name="deliveryNote"
                  options={deliveryNotesList}
                  placeholder="Bon de livraison"
                  required
                >
                  {t(
                    'ebat:entities:orders.modal.delivery_notes.choice_delivery',
                  )}
                </Field>
              )}
              <Field
                as={SelectField}
                context="format-field"
                disabled={isDisabled.disabled}
                errors={
                  errors.format &&
                  touched.format && [
                    t(`common:messages:forms.validation.${errors.format}`),
                  ]
                }
                id="format"
                name="format"
                options={deliveryNoteFormats}
                placeholder="Format"
                required
              >
                {t('ebat:entities:orders.modal.delivery_notes.format')}
              </Field>
            </div>
            <ButtonLoading
              context="delivery-notes-save"
              disabled={onIsDisabled(values)}
              isLoading={isDisabled.loading}
            >
              {t('common:messages:actions.valid')}
            </ButtonLoading>
          </Form>
        )}
      </Formik>
    </div>
  );
};

DeliveryNotes.defaultProps = {
  ...DeliveryNotesDefaultProps,
};

DeliveryNotes.propTypes = {
  ...DeliveryNotesPropTypes,
};

export default DeliveryNotes;
